import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

export function extractSampleFromStageRunSample(typedValue: TypedValue): TypedValue {
  if (typedValue.type === BaseTypedValueType.STAGE_RUN_SAMPLE) {
    return typedValue.stageRunSample.batch
      ? // Can't return a BATCH typed value, because it requires a fileId which the stageRunSample doesn't have
        {type: BaseTypedValueType.STRING, rawValue: typedValue.stageRunSample.name}
      : typedValue.stageRunSample.fileId
        ? {
            type: BaseTypedValueType.BIOENTITY,
            bioentitySummary: {
              id: typedValue.stageRunSample.fileId,
              name: typedValue.stageRunSample.name,
            },
          }
        : {type: BaseTypedValueType.STRING, rawValue: typedValue.stageRunSample.name};
  } else {
    return typedValue;
  }
}
